<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/63/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="zcjj">
                    <img class="top" style="height: 1.12rem" src="./../assets/imgs/xllh/rcgyysq_zcjj.png" alt="" />
                    <div class="content">
                        <div class="des">
                            为贯彻落实中央和省、市关于高层次人才队伍建设的总体要求，以“大人才观”为统揽，统筹开发外来人才和本土人才两种资源，从
                            2017
                            年起，面向我区电子信息、创新创业、食品加工等重点支柱产业及民生保障与公共服务领域，有计划、有步骤、有重点地遴选培养中青年优秀人才，造就一支具有领军潜能、创新潜力的优秀人才队伍。
                        </div>
                    </div>
                </div>
                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/63/title-1.png" alt="" />
                    <div class="content" style="font-weight: normal; font-size: 0.26rem">
                        全职在郫都区工作，年龄原则在 50
                        岁以下，区域内企事业单位、在我区注册并纳税的非公有制企业、在我区登记的社会组织中的中青年人才。
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/63/title-2.png" alt="" />
                    <div class="content" style="font-weight: normal; font-size: 0.26rem">
                        科技人才由区新科局负责选拔，经营管理人才由区经信局负责选拔，新兴服务业人才由区商务局负责选拔，青年（大学生）创业人才由双创委、团区委负责选拔，现代农业技术人才由区农业农村局负责选拔，社会工作专业人才由区民政局负责选拔，教育人才由区教育局负责选拔，卫生人才由区卫健局负责选拔，金融人才由区国资金融局负责选拔，高技能人才由区人社局负责选拔，高层次宣传文化旅游体育人才由区文体旅局负责选拔，扫码详见各行业遴选实施细则。
                    </div>
                </div>
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/63/title-3.png" alt="" />
                    <div class="content">
                        <div class="title" style="
                                            font-weight: normal;
                                            font-size: 0.28rem;
                                            margin-top: 0.13rem;
                                        "></div>
                        <div class="des mar-t2">
                            （一）给予每人20 万元的资助，分两年拨付，第一年拨付
                            10 万元，第二年经考核合格后拨付 10 万元。
                        </div>
                        <div class="des mar-t2">
                            （二）各牵头部门组织人才进行学习考察，并定期举办论坛、沙龙等活动，支持和鼓励培养对象开展学术交流、技术交流、项目合作等。
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/63/title-4.png" alt="" />
                    <div class="content">
                        <div style="margin-top: 0.22rem">
                            <span class="hollow-cricle"></span>
                            <span style="font-weight: bold; font-size: 0.34rem">（一）个人</span>
                        </div>
                        <div class="des">
                            <div class="line-item">
                                <div class="dot">1</div>
                                <div class="line"></div>
                                组织申报
                            </div>
                            <div class="line-item">
                                <div class="dot">2</div>
                                <div class="line"></div>
                                申报条件
                            </div>
                            <div class="line-item">
                                <div class="dot">3</div>
                                <div class="line"></div>
                                个人提交资料
                            </div>
                            <div class="line-item">
                                <div class="dot">4</div>
                                <div class="line"></div>
                                所在单位进行预审
                            </div>
                            <div class="line-item">
                                <div class="dot">5</div>
                                <div class="line"></div>
                                各牵头单位负责组织申报材料规范性、真实性进行初审
                            </div>
                            <div class="line-item">
                                <div class="dot">6</div>
                                <div class="line"></div>
                                各牵头部门商区委组织部拟定专家评审工作方案
                            </div>
                            <div class="line-item">
                                <div class="dot">7</div>
                                <div class="line"></div>
                                各牵头部门组织专家组对初审通过的建议人选进行择优评选
                            </div>
                            <div class="line-item">
                                <div class="dot">8</div>
                                <div class="line"></div>
                                各牵头部门将评审结果提交区委组织部
                            </div>
                            <div class="line-item">
                                <div class="dot">9</div>
                                <div class="line"></div>
                                区委组织部会同区人社局根据评审意见提出拟入选人员单，按区委人才工作领导小组确定拟培养对象
                            </div>
                            <div class="line-item">
                                <div class="dot">10</div>
                                <div class="line"></div>
                                拟培养对象公示5个工作日，接受社会监督
                            </div>
                            <div class="line-item">
                                <div class="dot">11</div>
                                公示后确定的入选对象纳入“郫都菁英百人培养计划”，由区委组织部与相应牵头部门颁发“郫都菁英百人培养计划入选证书”
                            </div>
                        </div>
                        <div style="margin-top: 0.22rem">
                            <span class="hollow-cricle"></span>
                            <span style="font-weight: bold; font-size: 0.34rem">（二）企业</span>
                        </div>
                        <div class="des">
                            <div class="line-item">
                                <div class="dot">1</div>
                                <div class="line"></div>
                                组织申报
                            </div>
                            <div class="line-item">
                                <div class="dot">2</div>
                                <div class="line"></div>
                                申报条件
                            </div>
                            <div class="line-item">
                                <div class="dot">3</div>
                                <div class="line"></div>
                                企业提交资料
                            </div>
                            <div class="line-item">
                                <div class="dot">4</div>
                                <div class="line"></div>
                                所在镇（街道）或产业园区预审
                            </div>
                            <div class="line-item">
                                <div class="dot">5</div>
                                <div class="line"></div>
                                各牵头单位负责组织申报材料规范性、真实性进行初审
                            </div>
                            <div class="line-item">
                                <div class="dot">6</div>
                                <div class="line"></div>
                                各牵头部门商区委组织部拟定专家评审工作方案
                            </div>
                            <div class="line-item">
                                <div class="dot">7</div>
                                <div class="line"></div>
                                各牵头部门组织专家组对初审通过的建议人选进行择优评选
                            </div>
                            <div class="line-item">
                                <div class="dot">8</div>
                                <div class="line"></div>
                                各牵头部门将评审结果提交区委组织部
                            </div>
                            <div class="line-item">
                                <div class="dot">9</div>
                                <div class="line"></div>
                                区委组织部会同区人社局根据评审意见提出拟入选人员单，按区委人才工作领导小组确定拟培养对象
                            </div>
                            <div class="line-item">
                                <div class="dot">10</div>
                                <div class="line"></div>
                                拟培养对象公示5个工作日，接受社会监督
                            </div>
                            <div class="line-item">
                                <div class="dot">11</div>
                                公示后确定的入选对象纳入“郫都菁英百人培养计划”，由区委组织部与相应牵头部门颁发“郫都菁英百人培养计划入选证书”
                            </div>
                        </div>
                        <div style="margin-top: 0.22rem">
                            <span class="hollow-cricle"></span>
                            <span style="font-weight: bold; font-size: 0.34rem">（三）事业单位</span>
                        </div>
                        <div class="des">
                            <div class="line-item">
                                <div class="dot">1</div>
                                <div class="line"></div>
                                组织申报
                            </div>
                            <div class="line-item">
                                <div class="dot">2</div>
                                <div class="line"></div>
                                申报条件
                            </div>
                            <div class="line-item">
                                <div class="dot">3</div>
                                <div class="line"></div>
                                事业单位提交资料
                            </div>
                            <div class="line-item">
                                <div class="dot">4</div>
                                <div class="line"></div>
                                各牵头单位负责组织申报材料规范性、真实性进行初审
                            </div>
                            <div class="line-item">
                                <div class="dot">5</div>
                                <div class="line"></div>
                                各牵头部门商区委组织部拟定专家评审工作方案
                            </div>
                            <div class="line-item">
                                <div class="dot">6</div>
                                <div class="line"></div>
                                各牵头部门组织专家组对初审通过的建议人选进行择优评选
                            </div>
                            <div class="line-item">
                                <div class="dot">7</div>
                                <div class="line"></div>
                                各牵头部门将评审结果提交区委组织部
                            </div>
                            <div class="line-item">
                                <div class="dot">8</div>
                                <div class="line"></div>
                                区委组织部会同区人社局根据评审意见提出拟入选人员单，按区委人才工作领导小组确定拟培养对象
                            </div>
                            <div class="line-item">
                                <div class="dot">9</div>
                                <div class="line"></div>
                                拟培养对象公示5个工作日，接受社会监督
                            </div>
                            <div class="line-item">
                                <div class="dot">10</div>
                                公示后确定的入选对象纳入“郫都菁英百人培养计划”，由区委组织部与相应牵头部门颁发“郫都菁英百人培养计划入选证书”
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/63/title-5.png" alt="" />
                    <div class="content">
                        每2年遴选一次，具体时间以区委组织部通知为准。
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/63/title-6.png" alt="" />
                    <div class="content">
                        <div class="number" style="padding-left: 4.05rem">
                            <span class="label">区委组织部（区委人才办）：</span>
                            <div>
                                <a href="tel:028-87987877">028-87987877</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <div>
                        <img class="code" src="../assets/imgs/63/code1.png" />
                        <img class="text" src="../assets/imgs/63/text1.png" />
                    </div>
                    <div>
                        <img class="code" src="../assets/imgs/63/code2.png" />
                        <img class="text" src="../assets/imgs/63/text2.png" />
                    </div>
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .zcjj {

            // background-color:#fff;
            .top {
                width: 6.68rem;
                height: 2.12rem;
            }

            .content {
                width: 6.68rem;
                background: #ffffff;
                margin: -0.45rem auto 0;
                padding: 0.1rem 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                line-height: 0.44rem;

                .title {
                    font-size: 0.34rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    line-height: 0.44rem;
                    text-align: left;
                    margin-top: 0.16rem;
                }
            }
        }

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.23rem;
                    text-align: left;
                    line-height: 0.44rem;
                    position: relative;
                    overflow: hidden;

                    .label {
                        width: 2.17rem;
                        height: 0.6rem;
                        background: #739bfe;
                        position: absolute;
                        top: 0;
                        display: flex;
                        left: 0;
                        align-items: center;
                        padding-left: 0.11rem;

                        color: #fff;

                        .letter {
                            width: 0.36rem;
                            height: 0.36rem;
                            background-color: #ffffff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 0.25rem 0px 0px 0px;
                            color: #739bfe;
                            margin-right: 0.12rem;
                            transform: translateY(-0.02rem);
                        }
                    }
                }
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.22rem;
                    position: relative;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;
                        padding-left: 0.5rem;
                        box-sizing: border-box;
                        margin-bottom: 0.35rem;

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 99999;
                        }

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 135%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.1rem;
                            z-index: 0;
                            top: 0.2rem;
                        }
                    }
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.3rem;
                font-weight: bold;
                text-align: left;
                color: #4e4e4e;
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.3rem;
                font-weight: bold;
                text-align: left;
                color: #4e4e4e;
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            &>div {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                width: 4.3rem;
            }
        }
    }
}
</style>
